import React from 'react';
import styles from './member_self_serve.module.scss';

// eslint-disable-next-line arrow-body-style
const TopMessageBanner = ({ message }) => {
  return <p className={styles.topMessageBanner}>{message}</p>;
};

export default TopMessageBanner;
